/**
 * Shared animated background for platform-themed pages (login, launcher, platform admin).
 * Renders orbs + sparkles + grid + overlay with variant-specific CSS classes.
 */
import { PlatformOrbs } from './PlatformOrbs';
import { PlatformSparkles } from './PlatformSparkles';

type Variant = 'login' | 'launcher' | 'platform-admin';

const CLASS_MAP: Record<Variant, { bg: string; grid: string; overlay: string }> = {
  login: { bg: 'login-bg', grid: 'login-bg-grid', overlay: 'login-overlay' },
  launcher: { bg: 'launcher-bg', grid: 'launcher-bg-grid', overlay: 'launcher-overlay' },
  'platform-admin': {
    bg: 'platform-admin-bg',
    grid: 'platform-admin-grid',
    overlay: 'platform-admin-overlay',
  },
};

export function PlatformBackground({ variant }: { variant: Variant }) {
  const cls = CLASS_MAP[variant];
  return (
    <>
      <div className={cls.bg} aria-hidden>
        <PlatformOrbs />
        <PlatformSparkles />
        <div className={cls.grid} />
      </div>
      <div className={cls.overlay} aria-hidden />
    </>
  );
}
